var map = {
	"./app/aajjo.webp": 33900,
	"./app/exportersindia.png": 92911,
	"./app/gmail.png": 10056,
	"./app/imap.png": 35049,
	"./app/indiamart.png": 9183,
	"./app/justdial.png": 94072,
	"./app/msg91.png": 90615,
	"./app/prasar-ai.png": 47648,
	"./app/razorpay.png": 46866,
	"./app/tradeindia.png": 19023,
	"./app/twilio.png": 30224,
	"./app/zoho.png": 1930,
	"./bg/authentication-bg-01.png": 44150,
	"./bg/authentication-bg-02.svg": 92489,
	"./bg/authentication-bg-03.svg": 67128,
	"./bg/authentication-bg-04.svg": 12055,
	"./bg/authentication-bg-05.svg": 23078,
	"./bg/authentication-bg-06.svg": 54853,
	"./bg/authentication-bg-07.svg": 57604,
	"./bg/authentication-bg-08.svg": 20883,
	"./bg/bg-01.png": 82763,
	"./bg/bg-02.png": 17360,
	"./bg/bg-03.png": 33113,
	"./bg/bg-black-le.svg": 6283,
	"./bg/bg-blue-01.svg": 65580,
	"./bg/bg-blue-le.svg": 46012,
	"./bg/bg-green-01.svg": 47579,
	"./bg/bg-pink-01.svg": 61292,
	"./bg/bg-pink-le.svg": 50332,
	"./bg/bg-purple-le.svg": 70010,
	"./bg/bg-yellow-01.svg": 46472,
	"./bg/card-bg-02.png": 47959,
	"./bg/card-bg-03.png": 48462,
	"./bg/card-bg-04.png": 46945,
	"./bg/card-bg-05.png": 25816,
	"./bg/card-bg.png": 16554,
	"./bg/coming-soon.svg": 36381,
	"./bg/email-bg-01.png": 31848,
	"./bg/email-bg-02.png": 93827,
	"./bg/error-404.svg": 65167,
	"./bg/error-500.svg": 91866,
	"./bg/job-bg-01.png": 45121,
	"./bg/job-bg-02.png": 96138,
	"./bg/job-bg-03.png": 51347,
	"./bg/job-bg-04.png": 51388,
	"./bg/modern-bg.png": 72567,
	"./bg/overlay-bg.png": 14494,
	"./bg/theme-bg.svg": 87379,
	"./bg/under-construction.svg": 61866,
	"./bg/under-maintenance.svg": 18738,
	"./bg/upgrade-bg.svg": 10126,
	"./bg/welcome-bg-01.svg": 66066,
	"./bg/welcome-bg-02.svg": 54753,
	"./bg/welcome-bg-03.svg": 42512,
	"./call/call-01.jpg": 24241,
	"./call/call-01.svg": 24879,
	"./call/call-02.jpg": 82822,
	"./call/call-03.jpg": 4995,
	"./call/call-04.jpg": 63344,
	"./call/call-05.jpg": 64269,
	"./call/call-06.jpg": 35010,
	"./company/company-01.svg": 74413,
	"./company/company-02.svg": 91438,
	"./company/company-03.svg": 6079,
	"./company/company-04.svg": 4960,
	"./company/company-05.svg": 2993,
	"./company/company-06.svg": 62242,
	"./company/company-07.svg": 49619,
	"./company/company-08.svg": 86340,
	"./company/company-09.svg": 83589,
	"./company/company-10.svg": 58991,
	"./company/company-11.svg": 31614,
	"./company/company-12.svg": 69437,
	"./company/company-13.svg": 96316,
	"./company/company-14.svg": 66499,
	"./company/company-15.svg": 35506,
	"./company/company-16.svg": 44993,
	"./company/company-17.svg": 9456,
	"./company/company-18.svg": 81575,
	"./company/company-19.svg": 17750,
	"./company/company-20.svg": 81434,
	"./company/company-21.svg": 96043,
	"./company/company-22.svg": 61656,
	"./company/company-23.svg": 49545,
	"./company/company-24.svg": 36454,
	"./company/company-25.svg": 34487,
	"./company/company-26.svg": 7716,
	"./company/company-27.svg": 58885,
	"./company/company-28.svg": 97890,
	"./download-img.png": 80626,
	"./favicon.png": 90286,
	"./file-manager/video-01.jpg": 48186,
	"./file-manager/video-02.jpg": 70789,
	"./file-manager/video-03.jpg": 8424,
	"./folder-open.svg": 94323,
	"./icons/android.svg": 57552,
	"./icons/angular.svg": 45495,
	"./icons/apple-logo.svg": 89239,
	"./icons/apple.svg": 90081,
	"./icons/audio.svg": 63823,
	"./icons/aws.svg": 59070,
	"./icons/black.svg": 92560,
	"./icons/channel-01.svg": 23796,
	"./icons/channel-02.svg": 95303,
	"./icons/channel-03.svg": 8182,
	"./icons/channel-04.svg": 83417,
	"./icons/channel-05.svg": 75496,
	"./icons/channel-06.svg": 56859,
	"./icons/channel-07.svg": 39018,
	"./icons/channel-08.svg": 59869,
	"./icons/clinic.svg": 3179,
	"./icons/close-circle.png": 812,
	"./icons/close-circle.svg": 17594,
	"./icons/cloud.svg": 93822,
	"./icons/company-icon-11.svg": 58409,
	"./icons/company-icon-12.svg": 13594,
	"./icons/company-icon-13.svg": 91115,
	"./icons/company-icon-14.svg": 23524,
	"./icons/company-icon-15.svg": 20773,
	"./icons/company-icon-16.svg": 88998,
	"./icons/company-icon-17.svg": 77975,
	"./icons/company-icon-18.svg": 42144,
	"./icons/connected-app-01.svg": 39074,
	"./icons/connected-app-02.svg": 9969,
	"./icons/connected-app-03.svg": 47168,
	"./icons/connected-app-04.png": 95429,
	"./icons/connected-app-04.svg": 89375,
	"./icons/delete.svg": 4738,
	"./icons/devops.svg": 16452,
	"./icons/drag-drop.svg": 31641,
	"./icons/drive.svg": 57057,
	"./icons/dropbox.svg": 14347,
	"./icons/emoji-01.svg": 72829,
	"./icons/emoji-smile.svg": 11824,
	"./icons/emonji-02.svg": 78640,
	"./icons/emonji-03.svg": 14177,
	"./icons/emonji-04.svg": 798,
	"./icons/emonji-05.svg": 28175,
	"./icons/emonji-06.svg": 49148,
	"./icons/emonji-07.svg": 38621,
	"./icons/emonji-08.svg": 51946,
	"./icons/emonji-09.svg": 12315,
	"./icons/emonji-10.svg": 37293,
	"./icons/facebook-logo.svg": 14981,
	"./icons/fb-icon.svg": 71987,
	"./icons/feeds-01.svg": 28930,
	"./icons/feeds-02.svg": 49297,
	"./icons/feeds-03.svg": 13344,
	"./icons/feeds-04.svg": 79231,
	"./icons/file-01.svg": 31755,
	"./icons/file-02.svg": 92920,
	"./icons/file-03.svg": 27785,
	"./icons/file-04.svg": 25190,
	"./icons/file-05.svg": 12727,
	"./icons/file.svg": 58469,
	"./icons/folder-icon.svg": 20143,
	"./icons/folder-minus.svg": 36828,
	"./icons/folder.svg": 34219,
	"./icons/global-img.svg": 91188,
	"./icons/google-icon-02.svg": 45111,
	"./icons/google-icon.svg": 68648,
	"./icons/google-logo.svg": 30734,
	"./icons/google-meet.svg": 29738,
	"./icons/grafic.svg": 35537,
	"./icons/half-circle.svg": 53421,
	"./icons/heart.svg": 45685,
	"./icons/hi.svg": 5586,
	"./icons/html.svg": 62100,
	"./icons/image.svg": 59682,
	"./icons/img.svg": 87496,
	"./icons/kanban-arrow.svg": 98130,
	"./icons/laravel-icon.svg": 91708,
	"./icons/laravel.svg": 91074,
	"./icons/like.svg": 99358,
	"./icons/liked-page-01.svg": 29626,
	"./icons/liked-page-02.svg": 71561,
	"./icons/liked-page-03.svg": 96056,
	"./icons/liked-page-04.svg": 91127,
	"./icons/medal-2.svg": 43469,
	"./icons/medal.svg": 71360,
	"./icons/modal-small-logo.svg": 60284,
	"./icons/nodejs.svg": 88202,
	"./icons/pause.svg": 34299,
	"./icons/pause1.svg": 43152,
	"./icons/pdf-02.svg": 99150,
	"./icons/pdf-icon.svg": 5079,
	"./icons/pdf.svg": 17603,
	"./icons/php-icon.svg": 4437,
	"./icons/php.svg": 33761,
	"./icons/play-01.svg": 90747,
	"./icons/polygon-icon.svg": 18995,
	"./icons/react.svg": 69264,
	"./icons/scanner.svg": 94075,
	"./icons/scanners.svg": 50194,
	"./icons/signature.svg": 76467,
	"./icons/smile-chat.svg": 18220,
	"./icons/sms-icon-01.svg": 89416,
	"./icons/sms-icon-02.svg": 70779,
	"./icons/sms-icon-03.svg": 28810,
	"./icons/smtp-icon.svg": 88075,
	"./icons/staff.svg": 75543,
	"./icons/storage-icon-01.svg": 74908,
	"./icons/storage-icon-02.svg": 53935,
	"./icons/storage-icon-03.svg": 10206,
	"./icons/storage.svg": 92470,
	"./icons/student.svg": 44900,
	"./icons/subject.svg": 47273,
	"./icons/success-tick.svg": 47246,
	"./icons/teacher.svg": 86203,
	"./icons/twitter-icon.svg": 47746,
	"./icons/ui.svg": 10541,
	"./icons/upgrade.svg": 50185,
	"./icons/video.svg": 57123,
	"./icons/voice.svg": 15903,
	"./icons/xls-icon.svg": 16504,
	"./icons/xls.svg": 20958,
	"./icons/zip.svg": 52776,
	"./img-01.jpg": 26171,
	"./img-02.jpg": 49196,
	"./img-03.jpg": 20809,
	"./img-04.jpg": 84346,
	"./img-05.jpg": 55511,
	"./img-1.jpg": 10569,
	"./img-2.jpg": 36862,
	"./img-3.jpg": 91643,
	"./img-4.jpg": 68968,
	"./img-5.jpg": 31333,
	"./join-call.jpg": 12199,
	"./join-call1.jpg": 41962,
	"./laptop-01.jpg": 84366,
	"./laptop-2.jpg": 2497,
	"./laptop-3.jpg": 8100,
	"./laptop.jpg": 25672,
	"./logo.webp": 31422,
	"./media/email-attach-01.jpg": 2953,
	"./media/email-attach-02.jpg": 59870,
	"./media/email-attach-03.jpg": 7707,
	"./media/email-attach-big-01.jpg": 18518,
	"./media/email-attach-big-02.jpg": 88865,
	"./media/email-attach-big-03.jpg": 10820,
	"./media/media-01.jpg": 83471,
	"./media/media-02.jpg": 69856,
	"./media/media-03.jpg": 20989,
	"./media/media-04.jpg": 66230,
	"./media/media-05.jpg": 36339,
	"./media/media-07.jpg": 36577,
	"./media/media-08.jpg": 69114,
	"./media/media-09.jpg": 32951,
	"./media/media-10.jpg": 27561,
	"./media/media-11.jpg": 72300,
	"./media/media-12.jpg": 49275,
	"./media/media-13.jpg": 47966,
	"./media/media-14.jpg": 95301,
	"./media/media-15.jpg": 67688,
	"./media/media-16.jpg": 78615,
	"./media/media-17.jpg": 91098,
	"./media/media-18.jpg": 68449,
	"./media/media-19.jpg": 90404,
	"./media/media-20.jpg": 7736,
	"./media/media-21.jpg": 15605,
	"./media/media-22.jpg": 89354,
	"./media/media-23.jpg": 61543,
	"./media/media-24.jpg": 55548,
	"./media/media-25.jpg": 60249,
	"./media/media-26.jpg": 69486,
	"./media/media-35.jpg": 77118,
	"./media/media-36.jpg": 50825,
	"./media/media-6.jpg": 51614,
	"./media/media-big-08.jpg": 83665,
	"./media/media-big-09.jpg": 69332,
	"./media/media-big-10.jpg": 39938,
	"./media/media-big-11.jpg": 59935,
	"./media/media-big-12.jpg": 44976,
	"./media/media-big-13.jpg": 72077,
	"./media/media-big-14.jpg": 78726,
	"./media/media-link-01.jpg": 52512,
	"./media/media-link-02.jpg": 42831,
	"./payment-gateway/country-01.svg": 40510,
	"./payment-gateway/country-02.svg": 52605,
	"./payment-gateway/country-03.svg": 40412,
	"./payment-gateway/country-04.svg": 68067,
	"./payment-gateway/country-05.svg": 18674,
	"./payment-gateway/payment-gateway-01.svg": 21569,
	"./payment-gateway/payment-gateway-02.svg": 28434,
	"./payment-gateway/payment-gateway-03.svg": 43075,
	"./payment-gateway/payment-gateway-04.svg": 72892,
	"./placeholder-img/apps/amazon.png": 34877,
	"./placeholder-img/apps/apple-store.png": 29541,
	"./placeholder-img/apps/apple.png": 7665,
	"./placeholder-img/apps/facebook.png": 55929,
	"./placeholder-img/apps/google.png": 13664,
	"./placeholder-img/apps/ibm.png": 96583,
	"./placeholder-img/apps/intel.png": 28621,
	"./placeholder-img/apps/microsoft.png": 9989,
	"./placeholder-img/apps/nvidia.png": 82068,
	"./placeholder-img/apps/paypal.png": 84256,
	"./placeholder-img/apps/play-store.png": 59631,
	"./placeholder-img/apps/tesla.png": 4664,
	"./placeholder-img/apps/visa.png": 96137,
	"./placeholder-img/backgrounds/1.png": 86745,
	"./placeholder-img/backgrounds/2.jpg": 9350,
	"./placeholder-img/backgrounds/3.png": 68139,
	"./placeholder-img/backgrounds/4.png": 18228,
	"./placeholder-img/backgrounds/5.png": 34909,
	"./placeholder-img/backgrounds/6.png": 53702,
	"./placeholder-img/backgrounds/7.png": 92719,
	"./placeholder-img/blog/1.jpg": 8560,
	"./placeholder-img/blog/10.jpg": 82762,
	"./placeholder-img/blog/11.jpg": 38599,
	"./placeholder-img/blog/12.jpg": 84792,
	"./placeholder-img/blog/13.jpg": 92661,
	"./placeholder-img/blog/14.jpg": 46542,
	"./placeholder-img/blog/15.jpg": 24587,
	"./placeholder-img/blog/16.jpg": 32604,
	"./placeholder-img/blog/17.jpg": 37305,
	"./placeholder-img/blog/18.jpg": 99266,
	"./placeholder-img/blog/19.jpg": 90975,
	"./placeholder-img/blog/2.jpg": 6559,
	"./placeholder-img/blog/20.jpg": 23631,
	"./placeholder-img/blog/21.jpg": 47250,
	"./placeholder-img/blog/22.jpg": 1405,
	"./placeholder-img/blog/3.jpg": 14850,
	"./placeholder-img/blog/4.jpg": 69457,
	"./placeholder-img/blog/5.jpg": 55124,
	"./placeholder-img/blog/6.jpg": 84835,
	"./placeholder-img/blog/7.jpg": 41702,
	"./placeholder-img/blog/8.jpg": 8245,
	"./placeholder-img/blog/9.jpg": 376,
	"./placeholder-img/books/1.jpg": 89136,
	"./placeholder-img/books/2.jpg": 73471,
	"./placeholder-img/books/3.jpg": 60802,
	"./placeholder-img/books/4.jpg": 50033,
	"./placeholder-img/books/5.jpg": 52660,
	"./placeholder-img/books/6.jpg": 30787,
	"./placeholder-img/file-manager/1.png": 60516,
	"./placeholder-img/file-manager/2.png": 74079,
	"./placeholder-img/file-manager/3.png": 95990,
	"./placeholder-img/gif/1.gif": 98083,
	"./placeholder-img/loader.svg": 12107,
	"./placeholder-img/media-1.jpg": 9072,
	"./placeholder-img/media-10.jpg": 46346,
	"./placeholder-img/media-11.jpg": 14087,
	"./placeholder-img/media-12.jpg": 34104,
	"./placeholder-img/media-13.jpg": 38421,
	"./placeholder-img/media-14.jpg": 80417,
	"./placeholder-img/media-15.jpg": 80843,
	"./placeholder-img/media-16.jpg": 96188,
	"./placeholder-img/media-17.jpg": 83065,
	"./placeholder-img/media-18.jpg": 32226,
	"./placeholder-img/media-19.jpg": 40287,
	"./placeholder-img/media-2.jpg": 92799,
	"./placeholder-img/media-20.jpg": 22415,
	"./placeholder-img/media-21.jpg": 46034,
	"./placeholder-img/media-22.jpg": 81341,
	"./placeholder-img/media-23.jpg": 55776,
	"./placeholder-img/media-24.jpg": 96083,
	"./placeholder-img/media-25.jpg": 24470,
	"./placeholder-img/media-26.jpg": 74081,
	"./placeholder-img/media-27.jpg": 96036,
	"./placeholder-img/media-28.jpg": 67895,
	"./placeholder-img/media-29.jpg": 96730,
	"./placeholder-img/media-3.jpg": 84738,
	"./placeholder-img/media-30.jpg": 58640,
	"./placeholder-img/media-31.jpg": 2093,
	"./placeholder-img/media-32.jpg": 69954,
	"./placeholder-img/media-33.jpg": 89951,
	"./placeholder-img/media-34.jpg": 65607,
	"./placeholder-img/media-35.jpg": 66513,
	"./placeholder-img/media-36.jpg": 8742,
	"./placeholder-img/media-37.jpg": 89795,
	"./placeholder-img/media-38.jpg": 7064,
	"./placeholder-img/media-39.jpg": 97973,
	"./placeholder-img/media-4.jpg": 69969,
	"./placeholder-img/media-40.jpg": 64109,
	"./placeholder-img/media-41.jpg": 95536,
	"./placeholder-img/media-42.jpg": 9887,
	"./placeholder-img/media-43.jpg": 1826,
	"./placeholder-img/media-44.jpg": 56433,
	"./placeholder-img/media-45.jpg": 42100,
	"./placeholder-img/media-46.jpg": 88163,
	"./placeholder-img/media-47.jpg": 28678,
	"./placeholder-img/media-48.jpg": 11573,
	"./placeholder-img/media-49.jpg": 3704,
	"./placeholder-img/media-5.jpg": 98164,
	"./placeholder-img/media-50.jpg": 14806,
	"./placeholder-img/media-51.jpg": 86419,
	"./placeholder-img/media-52.jpg": 86372,
	"./placeholder-img/media-53.jpg": 64417,
	"./placeholder-img/media-54.jpg": 36370,
	"./placeholder-img/media-55.jpg": 12751,
	"./placeholder-img/media-56.jpg": 46112,
	"./placeholder-img/media-57.jpg": 71677,
	"./placeholder-img/media-58.jpg": 27582,
	"./placeholder-img/media-59.jpg": 28891,
	"./placeholder-img/media-6.jpg": 44227,
	"./placeholder-img/media-60.jpg": 25115,
	"./placeholder-img/media-61.jpg": 4958,
	"./placeholder-img/media-62.jpg": 96457,
	"./placeholder-img/media-63.jpg": 82316,
	"./placeholder-img/media-64.jpg": 42551,
	"./placeholder-img/media-65.png": 54590,
	"./placeholder-img/media-66.png": 74965,
	"./placeholder-img/media-67.png": 63340,
	"./placeholder-img/media-68.png": 67355,
	"./placeholder-img/media-69.jpg": 45206,
	"./placeholder-img/media-7.jpg": 54118,
	"./placeholder-img/media-70.jpg": 32412,
	"./placeholder-img/media-71.jpg": 76761,
	"./placeholder-img/media-72.jpg": 78094,
	"./placeholder-img/media-73.jpg": 79960,
	"./placeholder-img/media-74.jpg": 70328,
	"./placeholder-img/media-75.jpg": 15157,
	"./placeholder-img/media-76.jpg": 91018,
	"./placeholder-img/media-77.jpg": 86823,
	"./placeholder-img/media-78.jpg": 39348,
	"./placeholder-img/media-79.jpg": 53073,
	"./placeholder-img/media-8.jpg": 90933,
	"./placeholder-img/media-80.svg": 17163,
	"./placeholder-img/media-81.svg": 11898,
	"./placeholder-img/media-82.jpg": 71179,
	"./placeholder-img/media-83.jpg": 93134,
	"./placeholder-img/media-84.jpg": 28757,
	"./placeholder-img/media-85.jpg": 24440,
	"./placeholder-img/media-9.jpg": 86616,
	"./placeholder-img/svg/pattern-1.svg": 64769,
	"./placeholder-img/svg/pattern-2.svg": 71634,
	"./placeholder-img/svg/pattern-3.svg": 86275,
	"./placeholder-img/svg/pattern-4.svg": 16092,
	"./products/product-01.jpg": 51150,
	"./products/product-02.jpg": 7289,
	"./products/product-03.jpg": 9916,
	"./products/product-04.jpg": 33703,
	"./products/product-05.jpg": 94698,
	"./products/product-06.jpg": 62037,
	"./profiles/avatar-01.jpg": 54802,
	"./profiles/avatar-02.jpg": 92605,
	"./profiles/avatar-03.jpg": 24512,
	"./profiles/avatar-04.jpg": 14675,
	"./profiles/avatar-05.jpg": 86262,
	"./profiles/avatar-06.jpg": 62049,
	"./profiles/avatar-07.jpg": 88452,
	"./profiles/avatar-08.jpg": 83607,
	"./profiles/avatar-09.jpg": 31674,
	"./profiles/avatar-10.jpg": 16880,
	"./profiles/avatar-11.jpg": 17805,
	"./profiles/avatar-12.jpg": 88546,
	"./profiles/avatar-13.jpg": 1215,
	"./profiles/avatar-14.jpg": 80404,
	"./profiles/avatar-15.jpg": 77777,
	"./profiles/avatar-16.jpg": 36358,
	"./profiles/avatar-17.jpg": 58531,
	"./profiles/avatar-18.jpg": 95032,
	"./profiles/avatar-19.jpg": 56213,
	"./profiles/avatar-20.jpg": 8385,
	"./profiles/avatar-21.jpg": 30340,
	"./profiles/avatar-22.jpg": 81971,
	"./profiles/avatar-23.jpg": 18806,
	"./profiles/avatar-24.jpg": 50269,
	"./profiles/avatar-25.jpg": 11040,
	"./profiles/avatar-26.jpg": 24655,
	"./profiles/avatar-27.jpg": 40370,
	"./profiles/avatar-28.jpg": 19081,
	"./profiles/avatar-29.jpg": 73708,
	"./profiles/avatar-30.jpg": 73962,
	"./profiles/avatar-31.jpg": 29799,
	"./profiles/mail-user.jpg": 72932,
	"./reports-img/approved-expense.svg": 8166,
	"./reports-img/check-icon.svg": 29238,
	"./reports-img/employee-report-danger.svg": 67953,
	"./reports-img/employee-report-icon.svg": 85035,
	"./reports-img/employee-report-info.svg": 65868,
	"./reports-img/employee-report-success.svg": 60369,
	"./reports-img/payment-report-icon.svg": 22069,
	"./reports-img/pending-expense.svg": 90842,
	"./reports-img/reject-expense.svg": 63866,
	"./reports-img/total-expense.svg": 20465,
	"./reports/user-01.jpg": 69285,
	"./reports/user-02.jpg": 46682,
	"./reports/user-03.jpg": 57495,
	"./reports/user-04.jpg": 3148,
	"./reports/user-05.jpg": 48521,
	"./reports/user-06.jpg": 74814,
	"./reports/user-07.jpg": 29595,
	"./reports/user-08.jpg": 40480,
	"./reports/user-09.jpg": 79709,
	"./reports/user-10.jpg": 57319,
	"./sending-img.png": 13322,
	"./settings/connected-app-01.svg": 13409,
	"./settings/connected-app-02.svg": 8370,
	"./settings/connected-app-03.svg": 11683,
	"./settings/connected-app-04.svg": 13756,
	"./settings/nexmo.jpg": 85631,
	"./settings/nexmo.svg": 61809,
	"./settings/phpmail.svg": 67749,
	"./settings/phpmailer.jpg": 87778,
	"./settings/sms-gateway.jpg": 64436,
	"./settings/sms-gateway.svg": 73762,
	"./settings/smtp.jpg": 63108,
	"./settings/smtp.svg": 27200,
	"./settings/twilio.jpg": 51480,
	"./settings/twilio.svg": 46392,
	"./sign.svg": 14093,
	"./social/facebook.svg": 53698,
	"./social/gallery-01.jpg": 23120,
	"./social/gallery-02.jpg": 54431,
	"./social/gallery-03.jpg": 18082,
	"./social/gallery-04.jpg": 30993,
	"./social/gallery-05.jpg": 52468,
	"./social/gallery-06.jpg": 54275,
	"./social/gallery-07.jpg": 73222,
	"./social/gallery-08.jpg": 62453,
	"./social/gallery-09.jpg": 71544,
	"./social/gallery-10.jpg": 67574,
	"./social/gallery-11.jpg": 54035,
	"./social/gallery-12.jpg": 59876,
	"./social/gallery-big-01.jpg": 60251,
	"./social/gallery-big-02.jpg": 83276,
	"./social/gallery-big-03.jpg": 54889,
	"./social/gallery-big-04.jpg": 18426,
	"./social/gallery.jpg": 63814,
	"./social/google.svg": 10979,
	"./social/pdf-icon.svg": 55906,
	"./social/project-01.svg": 72583,
	"./social/project-02.svg": 1076,
	"./social/project-03.svg": 26709,
	"./social/project-04.svg": 16298,
	"./social/project-05.svg": 34139,
	"./social/social-01.svg": 97133,
	"./social/social-02.svg": 48782,
	"./social/social-03.svg": 77215,
	"./social/social-04.svg": 11328,
	"./social/social-05.svg": 47281,
	"./social/social-06.svg": 26914,
	"./social/social-feed-01.jpg": 46464,
	"./social/social-feed-02.jpg": 36783,
	"./social/social-feed-03.jpg": 60402,
	"./social/social-feed-04.jpg": 84001,
	"./social/twitter.svg": 63775,
	"./supplier/edit-supplier.jpg": 43632,
	"./supplier/stock-img-01.png": 58701,
	"./supplier/supplier-01.png": 42277,
	"./theme/automatic.svg": 31057,
	"./theme/bg-01.jpg": 45343,
	"./theme/bg-02.jpg": 61008,
	"./theme/bg-03.jpg": 45581,
	"./theme/bg-04.jpg": 64134,
	"./theme/bg-05.jpg": 2659,
	"./theme/bg-06.jpg": 8180,
	"./theme/bordered.svg": 65849,
	"./theme/borderless.svg": 69777,
	"./theme/box.svg": 71975,
	"./theme/compact.svg": 53843,
	"./theme/dark.svg": 62440,
	"./theme/default.svg": 64947,
	"./theme/detached.svg": 58350,
	"./theme/horizontal-single.svg": 87561,
	"./theme/horizontal.svg": 30540,
	"./theme/hoverview.svg": 80341,
	"./theme/light.svg": 40328,
	"./theme/menu-aside.svg": 27342,
	"./theme/mini.svg": 66977,
	"./theme/modern.svg": 38225,
	"./theme/overlay.svg": 21343,
	"./theme/pattern-01.png": 51880,
	"./theme/pattern-01.svg": 95986,
	"./theme/pattern-02.png": 13859,
	"./theme/pattern-02.svg": 84673,
	"./theme/pattern-03.png": 24026,
	"./theme/pattern-03.svg": 93552,
	"./theme/rtl.svg": 34886,
	"./theme/shadow.svg": 58304,
	"./theme/sidebar-bg-01.svg": 56196,
	"./theme/sidebar-bg-02.svg": 99319,
	"./theme/sidebar-bg-03.svg": 11782,
	"./theme/sidebar-bg-04.svg": 14377,
	"./theme/sidebar-bg-05.svg": 79512,
	"./theme/sidebar-bg-06.svg": 18347,
	"./theme/stacked.svg": 56311,
	"./theme/transparent.svg": 19413,
	"./theme/two-column.svg": 22513,
	"./theme/without-header.svg": 99706,
	"./users/edit-user.jpg": 51535,
	"./users/user-01.jpg": 3380,
	"./users/user-02.jpg": 33091,
	"./users/user-03.jpg": 89958,
	"./users/user-04.jpg": 9037,
	"./users/user-05.jpg": 56816,
	"./users/user-06.jpg": 54815,
	"./users/user-07.jpg": 63106,
	"./users/user-08.jpg": 1145,
	"./users/user-09.jpg": 96444,
	"./users/user-10.jpg": 48346,
	"./users/user-11.jpg": 19511,
	"./users/user-12.jpg": 8584,
	"./users/user-13.jpg": 36197,
	"./users/user-14.jpg": 88862,
	"./users/user-15.jpg": 90171,
	"./users/user-16.jpg": 13196,
	"./users/user-17.jpg": 68457,
	"./users/user-18.jpg": 75269,
	"./users/user-19.jpg": 74031,
	"./users/user-20.jpg": 73855,
	"./users/user-21.jpg": 61186,
	"./users/user-22.jpg": 90445,
	"./users/user-23.jpg": 89520,
	"./users/user-24.jpg": 31171,
	"./users/user-25.jpg": 92646,
	"./users/user-26.jpg": 50417,
	"./users/user-27.jpg": 53044,
	"./users/user-28.jpg": 519,
	"./users/user-29.jpg": 88362,
	"./users/user-30.jpg": 83680,
	"./users/user-31.jpg": 22909,
	"./users/user-32.jpg": 13010,
	"./users/user-33.jpg": 80943,
	"./users/user-34.jpg": 2980,
	"./users/user-35.jpg": 81025,
	"./users/user-36.jpg": 91446,
	"./users/user-37.jpg": 54611,
	"./users/user-38.jpg": 50120,
	"./users/user-39.jpg": 12485,
	"./users/user-40.jpg": 55581,
	"./users/user-41.jpg": 87488,
	"./users/user-42.jpg": 77807,
	"./users/user-43.jpg": 1426,
	"./users/user-44.jpg": 25025,
	"./users/user-45.jpg": 51428,
	"./users/user-46.jpg": 77651,
	"./users/user-47.jpg": 49238,
	"./users/user-48.jpg": 51877,
	"./users/user-49.jpg": 7912,
	"./users/user-5.jpg": 98212,
	"./users/user-50.jpg": 82982,
	"./users/user-51.jpg": 21507,
	"./users/user-52.jpg": 43380,
	"./users/user-53.jpg": 40753,
	"./users/user-54.jpg": 51522,
	"./users/user-55.jpg": 64191,
	"./users/user-56.jpg": 79856,
	"./users/user-57.jpg": 80781,
	"./users/user-58.jpg": 65774,
	"./users/user-6.jpg": 40787,
	"./users/user-7.jpg": 96022,
	"./video/user-01.jpg": 28649,
	"./video/video.jpg": 475
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 21382;